import { render, staticRenderFns } from "./ServicesListView.vue?vue&type=template&id=01518ccd&scoped=true&"
import script from "./ServicesListView.vue?vue&type=script&lang=ts&"
export * from "./ServicesListView.vue?vue&type=script&lang=ts&"
import style0 from "./ServicesListView.vue?vue&type=style&index=0&id=01518ccd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01518ccd",
  null
  
)

export default component.exports